import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
  standalone: false,
})
export class ActionButtonComponent {
  @Input() src!: string;
  @Input() alt!: string;
  @Input() buttonText!: string;
  @Output() addItem = new EventEmitter();

  clickAddItem() {
    this.addItem.emit();
  }
}
